import React from "react";

const DateFilter = ({ selectedDate, setSelectedDate }) => {
  return (
    <div
      className={`timesheet_filter_body_block_heading_select ${
        selectedDate ? "has-selection" : ""
      }`}
    >
      <input
        type="date"
        className={`timesheet_filter_body_block_heading_select_input ${
          selectedDate ? "date-has-value" : ""
        }`}
        value={selectedDate}
        onChange={(e) => setSelectedDate(e.target.value)}
        placeholder="DD/MM/YYYY"
      />
    </div>
  );
};

export default DateFilter;
